// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1StatePermissionSchema = z.object({
  id: z.number().int(),
  role_id: z.number().int(),
  state_id: z.number().int(),
  team_lead: z.boolean(),
  project_lead: z.boolean(),
  operation: z.coerce.string(),
  updated_at: z.number().int(),
  created_at: z.number().int(),
});
